import React, {
  useMemo,
  useState,
  Fragment,
  useEffect,
  useCallback,
} from 'react';
import differenceBy from 'lodash/differenceBy';

import ConsentItem from '../ConsentItem';
import ConsentDetails from '../ConsentDetails';

export function useConsents({ details = {}, consents = [], onAccept }) {
  const [queue, setQueue] = useState([]);

  const [indexed, forAccept] = useMemo(() => {
    const indexed = consents.map((item, idx) => ({ ...item, idx: idx + 1 }));
    return [indexed, indexed.filter(({ accepted }) => !accepted)];
  }, [consents]);

  useEffect(() => {
    if (queue.length) {
      const [, ...next] = queue;
      setQueue(differenceBy(next, forAccept));
    }
  }, [forAccept]);

  const proxify = useCallback(
    handler => () => (forAccept.length ? setQueue(forAccept) : handler()),
    [forAccept],
  );

  const list = (
    <Fragment>
      {indexed.map(consent => (
        <ConsentItem
          key={consent.id}
          consent={consent}
          onClick={() => setQueue([consent])}
        />
      ))}

      <ConsentDetails
        details={details}
        consent={queue[0]}
        onAccept={onAccept}
        total={indexed.length}
        onClose={() => setQueue([])}
      />
    </Fragment>
  );

  return { list, proxify };
}



// WEBPACK FOOTER //
// ./src/components/Consents/hooks/useConsents.js